export const contentTypes = {
  name: 'Content types',
  url: '/admin/content',
  icon: 'fa fa-file',
  permissions: [89, 90, 91, 92, 93, 94],
  children: [
    {
      name: 'Articles',
      url: '/admin/content/article',
      icon: 'fa fa-newspaper-o',
      permissions: [104, 105, 106, 107, 108, 109],
    },
    {
      name: 'Audio',
      url: '/admin/content/media_audio',
      icon: 'fa fa-music',
      permissions: [181, 182, 183, 184, 185, 186],
    },
    {
      name: 'Audio Albums',
      url: '/admin/content/media_audio_album',
      icon: 'fa fa-music',
      permissions: [175, 176, 177, 178, 179, 180],
    },
    {
      name: 'Correspondence',
      url: '/admin/content/correspondence',
      icon: 'fa fa-file-text',
      permissions: [120, 121, 122, 123, 124, 125],
    },
    {
      name: 'Documents',
      url: '/admin/content/media_doc',
      icon: 'fa fa-file-text',
      permissions: [187, 188, 189, 190, 191, 192],
    },
    {
      name: 'Document Files',
      url: '/admin/content/document_files',
      icon: 'fa fa-file-text',
      permissions: [193, 194, 195, 196, 197, 198],
    },
    {
      name: 'Events',
      url: '/admin/content/event',
      icon: 'fa fa-newspaper-o',
      permissions: [126, 127, 128, 129, 130, 131],
    },
    {
      name: 'FAQ',
      url: '/admin/content/faq',
      icon: 'fa fa-question',
      permissions: [132, 133, 134, 135, 136, 137],
    },
    {
      name: 'Issues and Answers',
      url: '/admin/content/issues_and_answers',
      icon: 'fa fa-question',
      permissions: [248, 249, 250, 251, 252, 253],
    },
    {
      name: 'Images',
      url: '/admin/content/media_image',
      icon: 'fa fa-picture-o',
      permissions: [157, 158, 159, 160, 161, 162],
    },
    {
      name: 'Image Galleries',
      url: '/admin/content/media_image_gallery',
      icon: 'fa fa-picture-o',
      permissions: [151, 152, 153, 154, 155, 156],
    },
    {
      name: 'Lessons',
      url: '/admin/content/lesson',
      icon: 'fa fa-newspaper-o',
      permissions: [139, 140, 141, 142, 143, 144],
    },
    {
      name: 'Letterbooks',
      url: '/admin/content/book',
      icon: 'fa fa-book',
      permissions: [110, 111, 112, 113, 114, 115],
    },
    {
      name: 'Locations',
      url: '/admin/content/location',
      icon: 'fa fa-map-marker',
      permissions: [145, 146, 147, 148, 149, 150],
    },
    {
      name: 'News',
      url: '/admin/content/news',
      icon: 'fa fa-newspaper-o',
      permissions: [199, 200, 201, 202, 203, 204],
    },
    {
      name: 'Pamphlets',
      url: '/admin/content/pamphlet',
      icon: 'fa fa-file-text',
      permissions: [205, 206, 207, 208, 209, 210],
    },
    {
      name: 'People',
      url: '/admin/content/person',
      icon: 'fa fa-users',
      permissions: [211, 212, 213, 214, 215, 216, 217],
    },
    {
      name: 'Publications',
      url: '/admin/content/publication',
      icon: 'fa fa-book',
      permissions: [218, 219, 220, 221, 222, 223],
    },
    {
      name: 'Topics',
      url: '/admin/content/topic',
      icon: 'fa fa-newspaper-o',
      permissions: [242, 243, 244, 245, 246, 247],
    },
    {
      name: 'Q&A',
      url: '/admin/content/questions_and_answers',
      icon: 'fa fa-question',
      permissions: [224, 225, 226, 227, 228, 229],
    },
    {
      name: 'Video',
      url: '/admin/content/media_video',
      icon: 'fa fa-video-camera',
      permissions: [169, 170, 171, 172, 173, 174],
    },
    {
      name: 'Video Series',
      url: '/admin/content/media_video_series',
      icon: 'fa fa-video-camera',
      permissions: [163, 164, 165, 166, 167, 168],
    },
  ],
};

export const games = {
  name: 'Games',
  icon: 'fa fa-file',
  permissions: [254],
  children: [
    {
      name: 'Puzzle Game',
      url: '/admin/puzzle-game-images',
      icon: 'fa fa-gamepad',
    },
    {
      name: 'Memory Game',
      url: '/admin/memory-game-images',
      icon: 'fa fa-gamepad',
    },
    {
      name: 'Painting Game',
      url: '/admin/painting-game-images',
      icon: 'fa fa-gamepad',
    },
    {
      name: 'Quiz Game',
      url: '/admin/quiz-game-images',
      icon: 'fa fa-gamepad',
    },
  ],
};

export const menu = [
  {
    name: 'Dashboard',
    url: '/admin/dashboard',
    icon: 'icon-speedometer',
  },
  {
    name: 'Account Settings',
    url: '/admin/account-settings',
    icon: 'fa fa-search',
  },
  {
    name: 'Dashboard Search',
    url: '/admin/main-search',
    icon: 'fa fa-search',
    permissions: [230],
  },
  contentTypes,
  games,
  {
    name: 'Branch Offices',
    url: '/admin/branch-offices',
    icon: 'fa fa-map-marker',
    permissions: [118, 256],
  },
  {
    name: 'Featured Content',
    url: '/admin/featured-content',
    icon: 'fa fa-star',
    permissions: [100],
  },
  {
    name: 'Editors Picks',
    url: '/admin/editors-picks',
    icon: 'fa fa-file',
    permissions: [255],
  },
  {
    name: 'Users',
    url: '/admin/users',
    icon: 'fa fa-users',
    permissions: [95],
  },
  {
    name: 'Directors',
    url: '/admin/directors',
    icon: 'fa fa-users',
    permissions: [117],
  },
  {
    name: 'Staff',
    url: '/admin/staff',
    icon: 'fa fa-users',
    permissions: [116],
  },
  {
    name: 'Site Pages',
    url: '/admin/site-pages',
    icon: 'fa fa-file',
    permissions: [119],
  },
  {
    name: 'Roles',
    url: '/admin/roles',
    icon: 'fa fa-users',
    permissions: [96],
  },
  {
    name: 'Menus',
    url: '/admin/menu',
    icon: 'fa fa-bars',
    permissions: [102],
  },
  {
    name: 'Public Files',
    url: '/admin/public',
    icon: 'fa fa-file',
    permissions: [103],
  },
  {
    name: 'Taxonomy',
    url: '/admin/taxonomy/vocabulary',
    icon: 'fa fa-file',
    permissions: [231],
    children: [
      {
        name: 'Vocabulary',
        url: '/admin/taxonomy/vocabulary',
        icon: 'fa fa-book',
        permissions: [232, 233, 234, 235, 236],
      },
      {
        name: 'Terms',
        url: '/admin/taxonomy/terms',
        icon: 'fa fa-book',
        permissions: [237, 238, 239, 240, 241],
      },
    ],
  },
  {
    name: 'Redirects',
    url: '/admin/redirects',
    icon: 'fa fa-exchange',
    permissions: [98],
  },
  {
    name: 'Search settings',
    url: '/admin/search',
    icon: 'fa fa-search',
    permissions: [230],
  },
  {
    name: 'Media',
    url: '/admin/media',
    icon: 'fa fa-caret-square-o-right',
    permissions: [99],
  },
  {
    name: 'Flowpaper',
    url: '/admin/flowpaper',
    icon: 'fa fa-caret-square-o-right',
    permissions: [138],
  },
  {
    name: 'Robots settings',
    url: '/admin/robots',
    icon: 'fa fa-android',
    permissions: [97],
  },
];



// WEBPACK FOOTER //
// ./src/helpers/menu.js